import dayjs from 'dayjs'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)
dayjs.extend(timezone)

export const CDN = 'https://d1hi0tbu2kom2c.cloudfront.net'
export const EVENT_TZ = 'Asia/Dubai'

// Banners may be plain filenames (served from /img/events/) or absolute paths
// relative to the CDN root (e.g. /img/events/saliyat1.png).
export function bannerPath (banner) {
  if (!banner) return undefined
  return banner.startsWith('/') ? banner : `/img/events/${banner}`
}

export function bannerUrl (banner) {
  const path = bannerPath(banner)
  return path ? `${CDN}${path}` : undefined
}

// Resolve every usable image for the event, in display order.
export function eventImages (eventData) {
  const banners = Array.isArray(eventData?.banners)
    ? eventData.banners.filter(Boolean).map(bannerUrl)
    : []
  if (banners.length) return banners
  if (eventData?.socialShareBanner) return [bannerUrl(eventData.socialShareBanner)]
  if (eventData?.slug) return [`${CDN}/img/events/i/${eventData.slug}.jpg`]
  return []
}

// The hero/splash image. A dedicated splashBanner wins, otherwise the first
// gallery image is used so the header is never empty.
export function splashImage (eventData) {
  if (eventData?.splashBanner) return bannerUrl(eventData.splashBanner)
  return eventImages(eventData)[0]
}

export function formatDuration (durationMinutes) {
  const minutes = parseInt(durationMinutes, 10)
  if (!Number.isFinite(minutes) || minutes <= 0) return ''
  if (minutes < 60) return `${minutes} min`
  const hours = Math.floor(minutes / 60)
  const remaining = minutes % 60
  return remaining > 0
    ? `${hours}:${String(remaining).padStart(2, '0')} hrs`
    : `${hours} hrs`
}

// Human readable date (or date range) in the event timezone.
export function formatDateRange (dates) {
  const list = (Array.isArray(dates) ? dates : [dates]).filter(Boolean)
  if (!list.length) return ''
  const first = dayjs(list[0]).tz(EVENT_TZ)
  const last = dayjs(list[list.length - 1]).tz(EVENT_TZ)
  if (list.length === 1 || first.isSame(last, 'day')) {
    return first.format('ddd, D MMMM YYYY')
  }
  if (first.isSame(last, 'month')) {
    return `${first.format('ddd D')} – ${last.format('ddd D MMMM YYYY')}`
  }
  return `${first.format('ddd D MMM')} – ${last.format('ddd D MMM YYYY')}`
}

// Prices are stored in fils (cents). Render them as whole AED when possible.
export function formatPrice (cents) {
  if (cents === '' || cents === null || cents === undefined) return ''
  const value = Number(cents)
  if (!Number.isFinite(value)) return ''
  const amount = value / 100
  const formatted = Number.isInteger(amount)
    ? amount.toLocaleString('en-US')
    : amount.toFixed(2)
  return `AED ${formatted}`
}
